"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HIS_1 = __importDefault(require("./Logos/HIS"));
const Google_1 = __importDefault(require("./Logos/Google"));
const Zeals_1 = __importDefault(require("./Logos/Zeals"));
const logoMap = {
    his: HIS_1.default,
    google: Google_1.default,
    zeals: Zeals_1.default,
};
const CompanyLogo = (_a) => {
    var { company, scale = 1 } = _a, rest = __rest(_a, ["company", "scale"]);
    const Logo = logoMap[company];
    return react_1.default.createElement(Logo, Object.assign({ scale: scale }, rest));
};
exports.default = CompanyLogo;
